/**
 * PlaceholderEditForm - "Coming soon" placeholder for unimplemented forms
 */

import { Construction } from 'lucide-react'

interface PlaceholderEditFormProps {
  title: string
}

export function PlaceholderEditForm({ title }: PlaceholderEditFormProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <Construction className="w-10 h-10 text-muted-foreground/30 mb-3" />
      <p className="text-sm font-medium text-muted-foreground">
        {title}
      </p>
      <p className="text-xs text-muted-foreground/60 mt-1">
        This editor is coming soon
      </p>
    </div>
  )
}
